import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable()
export class ConsultantService {

  constructor( private  _authService: AuthService, private router : Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):Observable<boolean> | Promise<boolean> | boolean{
    
    if ((this._authService.isLoggedIn() && this._authService.isCollaborateur()) ) {
      return true;
    } else {
      this.router.navigate(['/home'])
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/gaurds/consultant.service.ts